import { useEffect, useState } from "react";
import { Mail, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { getOutlookStatus } from "@/lib/api";

// Parked: shows connection state; the Microsoft 365 OAuth hookup lands once
// the Azure app registration credentials are in place.
export function ConnectOutlookButton({ variant = "menu", testId = "btn-connect-outlook" }) {
  const [status, setStatus] = useState(null);

  useEffect(() => {
    getOutlookStatus().then((r) => setStatus(r.data)).catch(() => setStatus({ configured: false, connected: false }));
  }, []);

  const connected = !!status?.connected;
  const handleClick = () => {
    if (connected) return toast.info(`Outlook connected as ${status.email}`);
    if (!status?.configured) return toast.info("Outlook connection is not set up yet — needs the Microsoft 365 app registration. Parked for now.");
    toast.info("Outlook sign-in coming soon");
  };

  const label = connected ? `Outlook: ${status.email}` : "Connect Outlook";
  const Icon = connected ? CheckCircle2 : Mail;

  if (variant === "menu") {
    return (
      <Button variant="ghost" size="sm" className="w-full justify-start text-xs h-8" onClick={handleClick} data-testid={testId}>
        <Icon className={`w-3.5 h-3.5 mr-2 ${connected ? "text-emerald-600" : ""}`} />
        <span className="truncate">{label}</span>
        {!connected && <span className="ml-auto text-[10px] text-slate-400">Soon</span>}
      </Button>
    );
  }

  return (
    <div className="border rounded-lg p-3 bg-slate-50 border-slate-200 flex items-center justify-between gap-3" data-testid={`${testId}-panel`}>
      <div>
        <div className="text-sm font-semibold text-slate-900 flex items-center gap-2">
          <Icon className={`w-4 h-4 ${connected ? "text-emerald-600" : "text-slate-500"}`} />
          Outlook (Microsoft 365)
        </div>
        <div className="text-[11px] text-slate-500 mt-0.5">
          {connected
            ? `Sending from ${status.email} — emails land in your Sent Items.`
            : "Send proposals, invoices and POs from your own mailbox with the PDF attached. Not set up yet."}
        </div>
      </div>
      <Button size="sm" variant="outline" className="h-7 text-xs shrink-0" onClick={handleClick} data-testid={testId}>
        {connected ? "Connected" : "Connect Outlook"}
      </Button>
    </div>
  );
}

export default ConnectOutlookButton;
